import { FormControlLabel, Grid2, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";
import { IFormFieldKeyLookupManage } from "../../../_common/models/formFieldKeyLookup";
import { DataTypeAutoComplete } from "../../../_components/autocomplete/dataType.autocomplete";
import { StandardButton } from "../../../_components/button/primary.button";
import { toastr } from "../../../_components/toastr/toastr";
import { formFieldKeyLookupService } from "../../../_services/formFieldKeyLookup.service";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";

export function FormFieldKeyLookupManage(params: {
    emitOnSave: () => void,
    emitOnDelete: () => void,
}) {
    const navigate = useNavigate();
    const { formFieldKeyId, formFieldKeyLookupId, formTemplateSectionId } = useParams<{ formFieldKeyId: string, formFieldKeyLookupId: string, formTemplateSectionId: string }>();
    const _formFieldKeyId = Number(formFieldKeyId);
    const _formFieldKeyLookupId = Number(formFieldKeyLookupId);

    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [formFieldKeyActions, setFormFieldKeyActions] = useState([]);

    const [data, setData] = useState<IFormFieldKeyLookupManage>({
        id: 0,
        label: "",
        lookupValue: "",
        formFieldKeyId: _formFieldKeyId,
        showLabel: false,
        hasSelectCondition: false,
        selectConditionText: "",
        isCorrectAnswer: false,
        description: "",
        formFieldActionId: null,
        conditionFormFieldKeyId: 0,
        conditionFormFieldKeyValue: "",
        subValue: ""
    });

    function fetchData() {
        setIsLoading(true);
        return formFieldKeyLookupService
            .get(_formFieldKeyLookupId)
            .then(
                (json: any) => {
                    setData(json)
                }
            )
            .finally(() => setIsLoading(false));
    }

    useEffect(() => {
        if (!!_formFieldKeyLookupId)
            fetchData();
    }, [_formFieldKeyLookupId]);

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return formFieldKeyLookupService
            .submit(data)
            .then(
                () => {
                    toastr.success("Created successfully");
                    params.emitOnSave();
                    navigate(-1);
                },
                (e) => {
                    console.log(e);
                    toastr.error("Please verify that the form is valid");
                }
            )
            .finally(() => setIsSaving(false));
    }

    function remove(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return formFieldKeyLookupService
            .disable(data.id)
            .then(
                () => {
                    toastr.success("Deleted successfully");
                    params.emitOnDelete();
                    navigate(-1);
                },
                (e) => {
                    console.log(e);
                    toastr.error("Please verify that the form is valid");
                }
            )
            .finally(() => setIsSaving(false));
    }

    function handleChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: event.target.value } });
    };

    function disable() {
        setIsSaving(true);

        return formFieldKeyLookupService
            .disable(data.id)
            .then(
                () => {
                    toastr.success("Closed successfully");
                    params.emitOnSave();
                    navigate(-1);
                }
            )
            .finally(() => setIsSaving(false));
    }

    function handleChangeSwitch(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: !__data[event.target.name] } });
    };

    function handleChangeShowLabel(event: any) {

        setData((__data: any) => { return { ...__data, [event.target.name]: !__data[event.target.name], label: !__data[event.target.name] ? __data.lookupValue : "" } });
    };

    return (

        <ValidatorForm onSubmit={submit} noValidate>




            <Grid2 container spacing={1} >

                < Grid2 size={{ xs: 12 }}>
                    <StandardTextValidator
                        autoFocus
                        label="Option Value"
                        value={data.lookupValue}
                        name="lookupValue"
                        required
                        fullWidth
                        validators={['required']}
                        errorMessages={['This field is required']}
                        onChange={handleChange}
                    />
                </Grid2>

                < Grid2 size={{ xs: 12 }}>
                    <StandardTextValidator
                        autoFocus
                        label="Sub Value"
                        value={data.subValue}
                        helperText="Mostly used for license pricing"
                        name="subValue"
                        fullWidth
                        onChange={handleChange}
                    />
                </Grid2>

                < Grid2 size={{ xs: 12 }}>
                    <StandardTextValidator
                        autoFocus
                        label="Description"
                        value={data.description}
                        name="description"
                        fullWidth
                        onChange={handleChange}
                    />
                </Grid2>

                <Grid2 size={{ xs: 12 }}>
                    <FormControlLabel
                        control={<Switch checked={data.showLabel} onChange={handleChangeShowLabel} name="showLabel" />}
                        label="Show Label"
                    />
                </Grid2>

                <Grid2 size={{ xs: 12 }}>
                    <FormControlLabel
                        control={<Switch checked={data.hasSelectCondition} onChange={handleChangeSwitch} name="hasSelectCondition" />}
                        label="Has Select Condition"
                    />
                </Grid2>

                <Grid2 size={{ xs: 12 }}>
                    <FormControlLabel
                        control={<Switch checked={data.isCorrectAnswer}
                            onChange={handleChangeSwitch}
                            name="isCorrectAnswer" />}
                        label="Is Correct Answer"
                    />
                </Grid2>

                {data.showLabel === true &&
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            label="Option Label"
                            value={data.label}
                            name="label"
                            required
                            fullWidth
                            validators={['required']}
                            errorMessages={['This field is required']}
                            onChange={handleChange}
                        />
                    </Grid2>
                }

                {(data.hasSelectCondition === true) &&
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            label="Select Condition"
                            value={data.selectConditionText}
                            name="selectConditionText"
                            required
                            fullWidth
                            validators={['required']}
                            errorMessages={['This field is required']}
                            onChange={handleChange}
                        />
                    </Grid2>
                }

                <Grid2 size={{ xs: 6 }}>

                    <DataTypeAutoComplete
                        key="conditionFormFieldKeyId"
                        dataType={DataTypeEnum.ConditionFormFieldKey}
                        label="Condition Form Field Key"
                        hasParent={true}
                        parentId={Number(formTemplateSectionId)}
                        value={data.conditionFormFieldKeyId}
                        name={"conditionFormFieldKeyId"}
                        onChange={handleChange}
                    />
                </Grid2>

                <Grid2 size={{ xs: 6 }}>
                    <StandardTextValidator
                        label="Value"
                        value={data.conditionFormFieldKeyValue}
                        name="conditionFormFieldKeyValue"
                        required={!!data.conditionFormFieldKeyId}
                        fullWidth
                        validators={!!data.conditionFormFieldKeyId ? ['required'] : []}
                        errorMessages={!!data.conditionFormFieldKeyId ? ['This field is required'] : []}
                        onChange={handleChange}
                    />

                </Grid2>


                <Grid2 size={{ xs: (_formFieldKeyId > 0) ? 6 : 12 }}>
                    <StandardButton loading={isLoading} saving={saving} type="submit" icon="save">Save</StandardButton>
                </Grid2>

                {(_formFieldKeyId > 0) &&
                    <Grid2 size={{ xs: 6 }}>
                        <StandardButton saving={saving} loading={isLoading} onClick={disable} variant="error" type="button" icon="clear">Delete</StandardButton>
                    </Grid2>
                }

            </Grid2>
        </ValidatorForm >
    );
}